export interface GetPagesUrlProps<
  TQueryParameters extends Record<string, string>,
> {
  farmUuid?: string;
  fieldUuid?: string;
  cropSeasonUuid?: string;
  country?: string;
  locale?: string;
  queryParameters?: TQueryParameters;
  forRouting?: boolean;
}

export const getPagesUrl = <TQueryParameters extends Record<string, string>>({
  country,
  locale,
}: GetPagesUrlProps<TQueryParameters>) => {
  let prefix = '';

  if (country && locale) {
    prefix = `/${country}/${locale}`;
  } else if (country) {
    prefix = `/${country}`;
  } else if (locale) {
    prefix = `/${locale}`;
  }

  return {
    landingPageUrl: `${prefix}`,
    loginPageUrl: `${prefix}/login`,
  };
};
